import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { image } from './../../../Helpers';

import './type-one.css';

/**
 * Type one
 *
 * @class TypeOne
 * @extends {Component}
 */
class TypeOne extends Component {
  /**
   * render
   *
   * @returns JSX
   * @memberof TypeOne
   */
  render() {
    return (
      <div className="history-type-one">
        <div className="wrapper">
          <div className="history-type-one--item">
            {image(this.props.titulo_1, this.props.imagem_1)}
            
            {this.props.getInfo &&
              <div className="content">
                {this.props.getInfo(this.props.titulo_1, this.props.descricao_1)}
              </div>}
          </div>

          {this.props.getInfo && 
            <div className="history-type-one--item">
              {image(this.props.titulo_2, this.props.imagem_2)}
            
              <div className="content">
                {this.props.getInfo(this.props.titulo_2, this.props.descricao_2)}
              </div>
            </div>}
        </div>
      </div>
    )
  }
}

TypeOne.propTypes = {
  titulo_1: PropTypes.string.isRequired,
  titulo_2: PropTypes.string.isRequired,
  descricao_1: PropTypes.string,
  descricao_2: PropTypes.string,
  imagem_1: PropTypes.object.isRequired,
  imagem_2: PropTypes.object.isRequired,
  getInfo: PropTypes.func.isRequired,
}

export default TypeOne;